import React, { FormEvent, useState, useCallback } from 'react'

import { AppSvg, Button, FormattedHTMLMessage, newIcons, PinInput } from '@web/walter-ui-kit'
import { useIntl } from 'react-intl'
import s from './s.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'

interface Props {
    onClose: () => void
    onContinue: (pin: string) => void
    isLoading: boolean
}

// eslint-disable-next-line max-lines-per-function
function Code({ onClose, onContinue, isLoading }: Props) {
    const intl = useIntl()

    const [state, setState] = useState({
        pin: '',
        confirmPin: '',
        error: '',
        isConfirm: false,
    })

    const onApproveClick = useCallback(
        (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault()

            if (state?.isConfirm) {
                if (state.confirmPin !== state.pin) {
                    setState(s => ({
                        ...s,
                        error: intl.formatMessage(lang.pinsDontMatch),
                    }))
                    return
                }

                onContinue(state.pin)
            } else {
                if (state.pin?.length < 4) {
                    setState(s => ({
                        ...s,
                        error: intl.formatMessage(lang.enter4Digits),
                    }))
                    return
                }

                setState(s => ({
                    ...s,
                    isConfirm: true,
                    error: '',
                }))
            }
        },
        [intl, onContinue, state.confirmPin, state?.isConfirm, state.pin]
    )

    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80Pin} size={80} path="new-icons" />
                </div>
            }
            title={
                state?.isConfirm ? (
                    <FormattedHTMLMessage {...lang.titleConfirm} />
                ) : (
                    <FormattedHTMLMessage {...lang.titleNew} />
                )
            }
            dataPointer="pin_code"
        >
            <form onSubmit={onApproveClick} className={s.wrap}>
                {!state?.isConfirm ? (
                    <PinInput
                        key="pin"
                        value={state?.pin}
                        onChange={value => {
                            setState(s => ({ ...s, pin: value }))
                        }}
                        error={!!state?.error}
                        errorMessage={state?.error}
                        autofocus
                    />
                ) : (
                    <PinInput
                        key="confirm_pin"
                        value={state?.confirmPin}
                        onChange={value => {
                            setState(s => ({ ...s, confirmPin: value }))
                        }}
                        error={!!state?.error}
                        errorMessage={state?.error}
                        autofocus
                    />
                )}
                <div className={s.button}>
                    <Button dataPointer="close" size="l" onClick={onClose} fullWidth htmlButtonType="button">
                        <FormattedHTMLMessage {...lang.close} />
                    </Button>
                    <Button
                        dataPointer="continue"
                        size="l"
                        mode="primary"
                        htmlButtonType="submit"
                        fullWidth
                        isLoading={isLoading}
                    >
                        <FormattedHTMLMessage {...lang.continue} />
                    </Button>
                </div>
            </form>
        </ModalView>
    )
}

export default Code
